import InputSliderView from './InputSliderView';

export default InputSliderView;
